import { gql } from '@apollo/client';

export const APP_UI_SETTINGS = gql`
  mutation saveUISetting($appUISetting: AppUISettingDTO) {
    saveUISetting(appUISetting: $appUISetting)
  }
`;

export const UISETTING = gql`
  query uiSettingById($id: ID) {
    uiSettingById(id: $id) {
      id
      settingName
      settingValue
      isActive
    }
  }
`;

export const UI_SETTING_BY_NAME = gql`
  query findBySettingName($settingName: String) {
    findBySettingName(settingName: $settingName) {
      id
      settingName
      settingValue
      isActive
    }
  }
`;

export const UPDATE_UI_SETTING_STATUS = gql`
  mutation updateUISettingStatus($id: ID, $isActive: Boolean) {
    updateUISettingStatus(id: $id, isActive: $isActive)
  }
`;

export const FREEZE_MARKET = gql`
  mutation freezeMarket($applicationFreezeInputDTO: ApplicationFreezeInput) {
    freezeMarket(applicationFreezeInputDTO: $applicationFreezeInputDTO)
  }
`;

export const UPDATE_FREEZE_MARKET = gql`
  mutation updateFreezeMarket(
    $applicationFreezeInputDTO: ApplicationFreezeInput
  ) {
    updateFreezeMarket(applicationFreezeInputDTO: $applicationFreezeInputDTO)
  }
`;

export const GET_MARKET_STATUS = gql`
  query getMarketStatus(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    getMarketStatus(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      applicationFreezeStatuses {
        id
        freezeStatus
        applicationFreezeDetails {
          id
          freezeReason
          freezeTimestamp
          unfreezeTimestamp
          createdBy {
            id
          }
          createdTimestamp
          lastModifiedBy {
            id
          }
          lastModifiedTimestamp
        }
      }
    }
  }
`;

export const QUERY_UI_SETTINGS = gql`
  query uiSettings {
    uiSettings
  }
`;

export const APP_UI_SETTINGS_QUERY = gql`
  query appUISettings(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    appUISettings(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      appUISettings {
        id
        settingName
        settingValue
        isActive
        offerDemandType
        appUISettingType
        createdAt
        updatedAt
      }
    }
  }
`;

export const APP_SETTINGS_QUERY = gql`
  query appSettingByType($type: SettingType) {
    appSettingByType(type: $type) {
      type
      values {
        key
        value
      }
    }
  }
`;

export const GET_PRESIGNED_URL = gql`
  query getPreSignedPutUrl(
    $contentType: String
    $path: String
    $fileName: String
  ) {
    getPreSignedPutUrl(
      contentType: $contentType
      path: $path
      fileName: $fileName
    )
  }
`;

export const GET_FAQ_LIST = gql`
  query allFAQs(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
  ) {
    allFAQs(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
    ) {
      polystoxFAQs {
        id
        question
        answer
        status
        isDeleted
        updatedByUserId
        createdByUserId
        createdAt
        updatedAt
        faqCategory
      }
      totalPages
      totalCount
    }
  }
`;

export const CREATE_FAQ = gql`
  mutation createFAQ($createFAQ: createFAQInput) {
    createFAQ(createFAQ: $createFAQ) {
      id
    }
  }
`;

export const UPDATE_FAQ = gql`
  mutation updateFAQ($updateFAQ: updateFAQInput) {
    updateFAQ(updateFAQ: $updateFAQ) {
      id
    }
  }
`;

export const DELETE_FAQ = gql`
  mutation deleteFAQById($id: ID!) {
    deleteFAQById(id: $id)
  }
`;

export const BANNERS_POSITIONS_QUERY = gql`
  query bannerPositions(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    bannerPositions(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      bannerPositions {
        id
        promotionType
        listingType
        rowIndex
        columnIndex
        isAdvt
        status
        validityStartTime
        validityExpireTime
        imageUrl
        webImageUrl
        durationInSecs
        trader {
          id
          firstName
          lastName
        }
      }
      totalCount
      totalPages
    }
  }
`;

export const BANNERS_POSITIONS_SUBSCRIPTION = gql`
  subscription bannerPositions(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    bannerPositions(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      bannerPositions {
        id
        promotionType
        listingType
        rowIndex
        columnIndex
        isAdvt
        status
        validityStartTime
        validityExpireTime
        imageUrl
        webImageUrl
        durationInSecs
        trader {
          id
          firstName
          lastName
        }
      }
      totalCount
      totalPages
    }
  }
`;

export const BANNERS_POSITIONS_BY_ID = gql`
  query bannerPositionById($id: ID!) {
    bannerPositionById(id: $id) {
      bannerPositionById {
        id
        promotionType
        listingType
        rowIndex
        columnIndex
        isAdvt
        status
        validityStartTime
        validityExpireTime
        durationInSecs
        imageUrl
        trader {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const SAVE_BANNER = gql`
  mutation saveBannerPosition($bannerInput: bannerPositionInput) {
    saveBannerPosition(bannerInput: $bannerInput) {
      id
    }
  }
`;

export const DELETE_BANNER_POSITION = gql`
  mutation deleteBannerPosition($id: ID) {
    deleteBannerPosition(id: $id)
  }
`;
